// Same 9 languages as mobile i18n.js, loading the SAME locale JSON files
// (via the @locales alias) plus a small web-only overlay.
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from '@locales/en.json';
import es from '@locales/es.json';
import fr from '@locales/fr.json';
import tr from '@locales/tr.json';
import it from '@locales/it.json';
import ja from '@locales/ja.json';
import pt from '@locales/pt.json';
import ru from '@locales/ru.json';
import de from '@locales/de.json';
import {webStrings} from './webStrings';
import {getAppLanguage, getBrowserLanguageCode} from '../services/settings';

const base: Record<string, Record<string, string>> = {
  de,
  en,
  es,
  fr,
  it,
  ja,
  pt,
  tr,
  ru,
};

export const SUPPORTED_APP_LANGUAGES = Object.keys(base);

const resources = Object.fromEntries(
  Object.entries(base).map(([lng, translation]) => [
    lng,
    {translation: {...translation, ...(webStrings[lng] ?? {})}},
  ]),
);

const initialLanguage = (): string => {
  const saved = getAppLanguage();
  if (saved && SUPPORTED_APP_LANGUAGES.includes(saved)) {
    return saved;
  }
  const browser = getBrowserLanguageCode();
  return SUPPORTED_APP_LANGUAGES.includes(browser) ? browser : 'en';
};

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
